import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash-es'
// UTILS
import { Utils } from 'utils/Utils'
// API
// ACTIONS
// COMPONENTS
import SelectArea from 'components/select_area/SelectArea'
// CONSTANTS
// ASSETS

class SelectAreaContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      listCountry: [],
    }
  }

  componentDidMount() {
    Utils.addClassForHotLiveChat('ez-multiple-chat-hotline')
    Utils.setMinWidthPages()
    this.sortedCountry()
  }

  componentDidUpdate(prevProps) {
    const { areas } = this.props
    if ((JSON.stringify(prevProps.areas) !== JSON.stringify(areas))) {
      this.sortedCountry()
    }
  }
  
  sortedCountry() {
    const { areas } = this.props
    const listCountry = _.keys(_.groupBy(areas, 'country_code')).sort()
    this.setState({ listCountry })
  }

  render() {
    const { listCountry } = this.state
    const { areas, backgroundImage, switchCountry, passingParams } = this.props

    if (!_.size(listCountry)) return null

    return (
      <SelectArea
        areas={areas}
        backgroundImage={backgroundImage}
        switchCountry={switchCountry}
        listCountry={listCountry}
        passingParams={passingParams}
      />
    )
  }
}

SelectAreaContainer.propTypes = {
  areas: PropTypes.instanceOf(Array).isRequired,
  backgroundImage: PropTypes.string.isRequired,
  switchCountry: PropTypes.string.isRequired,
  passingParams: PropTypes.string.isRequired,
}

export default SelectAreaContainer
